import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox, InputAdornment, Stack, Typography } from '@mui/material';
import { AutosizedTextField } from '../../../../../../../components/common/AutosizedTextField';
export const NumericControl = ({ state, dispatch, stateKey: key, label, unitLabel, maxWidth }) => {
    const { valueSettings } = state;
    if (!valueSettings[key]) {
        return _jsx(Typography, { children: `Can't find key ${key}` });
    }
    else
        return (_jsx(Stack, { direction: 'row', alignItems: 'center', children: _jsx(AutosizedTextField, { label,
                disabled: !valueSettings[key].include,
                value: valueSettings[key].value,
                onChange: (e) => dispatch({ type: 'UpdateValue', update: { key, v: parseInt(e.target.value) } }),
                slotProps: {
                    input: {
                        type: 'number',
                        sx: { maxWidth },
                        startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(Checkbox, { checked: valueSettings[key].include,
                                sx: { padding: 0 },
                                onClick: () => {
                                    dispatch({ type: 'TogglePresence', update: { key } });
                                } }) })),
                        endAdornment: _jsx(InputAdornment, { position: "end", children: unitLabel }),
                    },
                } }) }));
};
